import { useCapabilityValue } from '../../store/devices/useCapabilityValue';

import { publicUrl } from '../../theme/functions/publicUrl';

export function IndicatorSpeaker({ device }) {
  const [value, , capabilityObj] = useCapabilityValue({
    capabilityId: 'speaker_playing',
    deviceId: device.id,
  });

  if (capabilityObj == null) {
    return null;
  }

  return (
    <img
      alt="speaker playing gif"
      src={publicUrl('img/indicators/equalizer.gif')}
      style={{
        width: 24,
        height: 24,
        opacity: value ? 1 : 0,
        transition: 'opacity 500ms ease-in-out',
      }}
    />
  );
}
